import { HttpClient } from '@angular/common/http';
import {Logger} from 'src/app/core/interfaces/Logger';
import {catchError, map, Observable, throwError} from "rxjs";
import {HttpBodyResponse} from "../../../core/api-dto/interface/api-http-response.interface";
import {buildHttpParams} from "../../utils/http.utils";
import {Injectable} from "@angular/core";

@Injectable()
export abstract class BaseHttpService {
  protected abstract baseUrl: string;

  constructor(
    protected readonly http: HttpClient,
    protected readonly logger: Logger
  ) {}

  protected get<T>(
    endpoint = '',
    queryParams?: Record<string, unknown>
  ): Observable<T> {
    const params = buildHttpParams(queryParams);

    return this.makeRequest<T>(
      this.http.get<HttpBodyResponse<T>>(
        this.resolveUrl(endpoint),
        { params }
      )
    );
  }

  protected post<T>(endpoint: string, payload: unknown): Observable<T> {
    return this.makeRequest<T>(
      this.http.post<HttpBodyResponse<T>>(this.resolveUrl(endpoint), payload)
    );
  }

  protected put<T>(endpoint: string, payload: unknown): Observable<T> {
    return this.makeRequest<T>(
      this.http.put<HttpBodyResponse<T>>(this.resolveUrl(endpoint), payload)
    );
  }

  private resolveUrl(endpoint: string): string {
    return `${this.baseUrl}/${endpoint}`.replace(/\/$/, '');
  }

  private makeRequest<T>(
    request$: Observable<HttpBodyResponse<T>>
  ): Observable<T> {
    return request$.pipe(
      map(response => response?.data ?? (response as unknown as T)),
      catchError(error => {
        this.logger.error(error, '[HttpService] Request failed');

        return throwError(() => error);
      })
    );
  }
}
